import { ContentTypeAction } from '../types/ContentTypeAction';
import { ContentTypeData } from '../types/ContentTypeData';

interface ContentTypeState {
  list: ContentTypeData[],
};

const initialState: ContentTypeState = {
  list: [],
};

const contentTypeReducers = (state = initialState, action: ContentTypeAction) => {
  switch (action.type) {
    case 'CONTENT_TYPE_SUCCESS': {
      return { ...state, list: action.data }
    }
    default:
      return state;
  }
}


export default contentTypeReducers;